// utils/session.js

const EXPIRATION_TIME = 15 * 60 * 1000; // 15 minutos

export function login(token) {
  const now = Date.now();
  const session = {
    token,
    expiresAt: now + EXPIRATION_TIME,
    lastActivity: now,
  };
  localStorage.setItem('session', JSON.stringify(session));
}

export function logout() {
  localStorage.removeItem('session');
  localStorage.removeItem('user');
}

export function getSession() {
  const session = JSON.parse(localStorage.getItem('session'));
  if (!session) return null;

  const now = Date.now();

  // Si expiró por tiempo o inactividad
  if (
    now > session.expiresAt ||
    now - session.lastActivity > EXPIRATION_TIME
  ) {
    logout();
    return null;
  }

  // Refrescar actividad
  session.lastActivity = now;
  localStorage.setItem('session', JSON.stringify(session));
  return session;
}

export function isAuthenticated() {
  return !!getSession();
}

export function getToken() {
  const session = getSession();
  return session ? session.token : null;
}

export function renewSession() {
  const session = getSession();
  if (!session) return;
  const now = Date.now();
  const renewed = {
    ...session,
    expiresAt: now + EXPIRATION_TIME,
    lastActivity: now,
  };
  localStorage.setItem('session', JSON.stringify(renewed));
}

export function getUser() {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
}

export function getUserType() {
  const user = getUser();
  return user?.tipo || null;
}

